import { DateIcon } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import React, { FunctionComponent } from 'react';
import DotsMenu from '../DotsMenu';
import SelectInput from '../Form/Inputs/SelectInput';
import styles from './TimeIntervalFilter.module.scss';

interface Props {
  compId: string;
  handleChangeTime?: (e: string) => void;
  hideInput?: boolean;
  allTimeInterval?: boolean;
  hideDotsMenu?: boolean;
  weekTimeInterval?: boolean;
  monthTimeInterval?: boolean;
  weekTimeIntervalWithDay?: boolean;
  monthTimeIntervalWithoutDay?: boolean;
  isReport?: boolean;
}

export const all_time_interval = [
  { label: _t('basic:all_time'), value: 'ALL' },
  { label: _t('basic:day'), value: 'DAY' },
  { label: _t('basic:week'), value: 'WEEK' },
  { label: _t('basic:month'), value: 'MONTH' },
  { label: _t('basic:year'), value: 'YEAR' },
];

export const time_interval = [
  { label: _t('basic:day'), value: 'DAY' },
  { label: _t('basic:week'), value: 'WEEK' },
  { label: _t('basic:month'), value: 'MONTH' },
  { label: _t('basic:year'), value: 'YEAR' },
];

export const time_interval_week = [
  { label: _t('basic:week'), value: 'WEEK' },
  { label: _t('basic:month'), value: 'MONTH' },
  { label: _t('basic:year'), value: 'YEAR' },
];

const TimeIntervalFilter: FunctionComponent<Props> = ({
  compId,
  handleChangeTime,
  hideInput,
  allTimeInterval,
  hideDotsMenu,
  weekTimeInterval,
  monthTimeInterval,
  weekTimeIntervalWithDay,
  monthTimeIntervalWithoutDay,
  isReport,
}) => {
  return (
    <div
      className={styles.TimeIntervalFilter}
      data-testid="time-interval-filter"
      id={compId}
    >
      <div className={styles.__toolBar}>
        <div className={styles.Filters}>
          {!hideInput && (
            <div className={styles.Select} data-testid="time-interval-holder">
              <SelectInput
                name={compId}
                placeholder={
                  allTimeInterval
                    ? all_time_interval[0].label
                    : weekTimeInterval
                    ? time_interval_week[0].label
                    : weekTimeIntervalWithDay
                    ? time_interval_week[0].label
                    : monthTimeInterval || monthTimeIntervalWithoutDay
                    ? time_interval[2].label
                    : time_interval[0].label
                }
                icon={<DateIcon />}
                options={
                  allTimeInterval
                    ? all_time_interval
                    : weekTimeInterval || monthTimeIntervalWithoutDay
                    ? time_interval_week
                    : time_interval
                }
                onChange={(e) => handleChangeTime?.(e.value)}
              />
            </div>
          )}
        </div>
        {!hideDotsMenu && (
          <div className={styles.Actions}>
            {!isReport && <DotsMenu id={compId} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default TimeIntervalFilter;
